/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_NoteInputs */

const en_mk_tut_note = /** @type {(inputs: Mk_Tut_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You do not have to read all of it at once. Parts 1 and 2 are enough to get working today; the rest can wait until you actually need the feature. The table of contents on the left groups it by part.`)
};

const id_mk_tut_note = /** @type {(inputs: Mk_Tut_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda tidak perlu membaca semuanya sekaligus. Bagian 1 dan 2 sudah cukup untuk bekerja hari ini; sisanya dibaca ketika fiturnya memang dibutuhkan. Daftar isi di kiri mengelompokkannya per bagian.`)
};

/**
* | output |
* | --- |
* | "You do not have to read all of it at once. Parts 1 and 2 are enough to get working today; the rest can wait until you actually need the feature. The table of..." |
*
* @param {Mk_Tut_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_note = /** @type {((inputs?: Mk_Tut_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_note(inputs)
	return en_mk_tut_note(inputs)
});